import React, { useContext } from 'react';
import Findings from '../Inspections/Findings/Findings';
import { InspectionContext } from '../../contexts/InspectionContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getInspectionTypeLabel } from '../../utils';

type InspectionInfoProps = {
  title: string;
  projectName: string;
  clientName: string;
  inspectionNumber: number;
  inspectionId: number;
}

const InspectionInfo: React.FC<InspectionInfoProps> = ({
  title,
  projectName,
  clientName,
  inspectionNumber,
  inspectionId
}) => {

  return (
    <header className='inspection-header guest-page-header'>
      <div className='inspection-header-info text-truncate'>
        <h2 className='inspection-header__title'>{title.split('|')[0]} | <span className='inspection-header__inspection-type'>{title.split('|')[1]}</span></h2>
        <h5>
          <FontAwesomeIcon icon='hashtag' className='header-icon' />
          {inspectionNumber} | ID {inspectionId}
        </h5>
        <h5>
          <FontAwesomeIcon icon='folder' className='header-icon' />
          {projectName}
        </h5>
        <h5>
          <FontAwesomeIcon icon='user' className='header-icon' />
          {clientName}
        </h5>
      </div>
    </header>
  );
};

const GuestFindingLanding = () => {
  const inspectionContext = useContext(InspectionContext);
  const { inspection } = inspectionContext;

  if (!inspection || !inspection.id) {
    return null;
  }

  return (
    <>
      <InspectionInfo
        title={getInspectionTypeLabel(inspection)}
        projectName={inspection.project?.name || ''}
        clientName={inspection.project?.client?.name || ''}
        inspectionNumber={inspection.number || 0}
        inspectionId={inspection.id}
      />
      <Findings />
    </>
  );
};

export default GuestFindingLanding